import React from 'react';

function ResultsPage({ capturedImage, faceShape, faceRatio, answers, onReset }) {
  return (
    <div className="bg-white rounded-lg shadow-xl p-8">
      <h1 className="text-3xl font-bold text-gray-800 mb-6 text-center">
        Your Results
      </h1>

      {/* Image */}
      <div className="mb-6">
        <img
          src={capturedImage}
          alt="Your face"
          className="w-full max-h-96 object-contain rounded-lg shadow-md mx-auto"
        />
      </div>

      {/* Face Shape Result */}
      <div className="mb-8 text-center">
        <p className="text-xl text-gray-700 mb-2">
          Your face shape is likely{' '}
          <span className="text-blue-600 font-bold">{faceShape}</span>
        </p>
      </div>

      {/* Summary */}
      <div className="bg-gray-50 rounded-lg p-6 mb-6">
        <h2 className="text-xl font-semibold text-gray-800 mb-4">Summary of Your Answers</h2>
        
        <div className="space-y-3">
          {/* Face Ratio */}
          <div className="flex justify-between items-center border-b border-gray-200 pb-2">
            <span className="text-gray-600 font-medium">Face Ratio:</span>
            <span className="text-gray-800">{faceRatio.toFixed(2)}</span>
          </div>

          {/* Jaw Shape */}
          <div className="flex justify-between items-center border-b border-gray-200 pb-2">
            <span className="text-gray-600 font-medium">Jaw Shape:</span>
            <span className="text-gray-800 capitalize">{answers[2]?.replace('-', ' ') || 'N/A'}</span>
          </div>

          {/* Widest Part */}
          <div className="flex justify-between items-center">
            <span className="text-gray-600 font-medium">Widest Part:</span>
            <span className="text-gray-800">{answers[3] || 'N/A'}</span>
          </div>
        </div>
      </div>

      {/* Reset Button */}
      <button
        onClick={onReset}
        className="w-full bg-blue-600 hover:bg-blue-700 text-white font-semibold py-3 px-6 rounded-lg transition duration-200 shadow-md"
      >
        Start Over
      </button>
    </div>
  );
}

export default ResultsPage;
